<template>
  <div class="emission-chart month-chart">
    <div class="chart">
      <!-- header for mobile -->
      <div class="header">
        <div class="header-left">
          <button
            type="button"
            class="btn-action"
            :disabled="isDisabledPrev"
            @click="handleViewPrev"
            @mouseover="isMouseOverPrev = true"
            @mouseleave="isMouseOverPrev = false"
            @mousedown="isBlurPrev = true"
            @mouseup="isBlurPrev = false"
          >
            <img :src="`/img/icons/${prevIcon}.svg`" alt="prev" preload />
          </button>
        </div>
        <div class="header-right">
          <button
            type="button"
            class="btn-action"
            :disabled="isDisabledNext"
            @click="handleViewNext"
            @mouseover="isMouseOverNext = true"
            @mouseleave="isMouseOverNext = false"
            @mousedown="isBlurNext = true"
            @mouseup="isBlurNext = false"
          >
            <img :src="`/img/icons/${nextIcon}.svg`" alt="Next" preload />
          </button>
        </div>
      </div>
      <!-- body -->
      <div class="content">
        <div class="content-left" ref="axisYRef" :style="{ 'min-width': axisYMinWidth }">
          <div class="axisY">
            <div
              v-for="(item, index) in axisYItemsSource"
              :key="index"
              class="axis-item"
              :class="{ unit: index === AXIS_Y_ITEM_COUNT }"
              :style="{ bottom: `${item.percent}%` }"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
        <div class="content-center">
          <div class="transition" :style="{ width: transitionWidth }"></div>
          <div
            v-for="(item, index) in dataChartPrepared"
            :key="index"
            class="chart-bar"
            :class="{ selected: item.time_range === selectedTimeRange, hovered: item.time_range === hoverTimeRange }"
            @click="handleGetValueChart(item)"
            @mouseover="handleMouseOver(item)"
            @mouseleave="handleMouseLeave"
          >
            <div class="active"></div>
            <div class="hover"></div>
            <div class="chart-wrapper">
              <template>
                <div
                  v-if="item.isHasPositiveProduct"
                  class="positive-number"
                  :style="{ height: `calc(100% - ${item.zero_value_ratio})`, bottom: item.zero_value_ratio }"
                >
                  <div
                    v-for="(productMaster, productMasterIndex) in item.positiveProduct"
                    :key="productMasterIndex"
                    class="bar animation"
                    :style="productMaster.style"
                    @mouseover="toolTipOn(productMaster)"
                    @mouseleave="toolTipOff"
                    @mousemove="updateTooltipPosition"
                  ></div>
                </div>
                <div v-if="isNegativeNumber" class="zero-crossline" :style="{ height: item.zero_value_ratio }"></div>
                <div
                  v-if="item.isHasNegativeProduct"
                  class="negative-number"
                  :style="{ height: item.zero_value_ratio }"
                >
                  <div
                    v-for="(productMaster, productMasterIndex) in item.negativeProduct"
                    :key="productMasterIndex"
                    class="bar animation"
                    :style="productMaster.style"
                    @mouseover="toolTipOn(productMaster)"
                    @mouseleave="toolTipOff"
                    @mousemove="updateTooltipPosition"
                  ></div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- footer -->
      <div class="footer">
        <div class="footer-left" :style="{ width: footerWidth + 'px' }">
          <button
            type="button"
            class="btn-action"
            :disabled="isDisabledPrev"
            @click="handleViewPrev"
            @mouseover="isMouseOverPrev = true"
            @mouseleave="isMouseOverPrev = false"
            @mousedown="isBlurPrev = true"
            @mouseup="isBlurPrev = false"
          >
            <img :src="`/img/icons/${prevIcon}.svg`" alt="prev" preload />
          </button>
        </div>

        <div class="footer-center">
          <div class="axisX">
            <div
              v-for="(item, index) in axisXItemsSource"
              :key="index"
              class="axis-item"
              :class="{ active: item.value === selectedTimeRange }"
            >
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>

        <div class="footer-right">
          <button
            type="button"
            class="btn-action"
            :disabled="isDisabledNext"
            @click="handleViewNext"
            @mouseover="isMouseOverNext = true"
            @mouseleave="isMouseOverNext = false"
            @mousedown="isBlurNext = true"
            @mouseup="isBlurNext = false"
          >
            <img :src="`/img/icons/${nextIcon}.svg`" alt="Next" preload />
          </button>
        </div>
      </div>
    </div>
    <div class="chart-next">
      <div class="header-right">
        <button
          type="button"
          class="btn-action"
          :disabled="isDisabledNext"
          @click="handleViewNext"
          @mouseover="isMouseOverNext = true"
          @mouseleave="isMouseOverNext = false"
          @mousedown="isBlurNext = true"
          @mouseup="isBlurNext = false"
        >
          <img :src="`/img/icons/${nextIcon}.svg`" alt="Next" preload />
        </button>
      </div>
    </div>
    <!-- tooltip -->
    <div
      id="emission-tooltip"
      class="emission-tooltip"
      :style="emissionTooltip.tooltipPosition"
      v-if="emissionTooltip.open"
      @mouseleave="toolTipOff"
    >
      <div class="container">
        <div class="text name" :style="emissionTooltip.data.style">
          {{ emissionTooltip.data.disp_title }}
        </div>
        <div class="text emission">
          <div class="text total">{{ emissionTooltip.data.disp_emission }}</div>
          <div class="text unit">{{ emissionTooltip.data.disp_emission_unit }}</div>
        </div>

        <div v-if="isFilterTypeProduct && emissionTooltip.data.name !== 'other'" class="text prod-detail">
          <a class="prod-detail-link" :href="redirectLinkHrefToDetailProduct(emissionTooltip.data)">
            {{ emissionTooltip.data.disp_link_detail }}
          </a>
        </div>
      </div>
    </div>
    <!-- end tooltip -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { UNIT_SETTING } from '@/constants/dashboard';
import { TABLET_WIDTH } from '@/constants/screen-size';
import { formatNumberByConditions } from '@/utils/convertNumber';
import { getUnitNewDashboardCFP } from '@/utils/new-cfp-dashboard';
import { isDashboardProductCFP } from '@/api/product/emissionsProduct';
import { formatDateRangeNewDashboardChart } from '@/utils/datetimeFormat';
import { prepareChartAxisY, getMinWidthYAxisChartColumn } from '@/concerns/chart';
import {
  formatValue,
  $_helper_isNumberType,
  $_helper_isNegativeNumber,
  math,
  formatBigNumber,
} from '@/concerns/newRegisterData/wijmo.helper';
import { DASHBOARD_COLOR } from '@/constants/products/define-data';
import { getIndexFromStoreData, DASHBOARD_TYPE } from '@/utils/dashboard';
const AXIS_Y_ITEM_COUNT = 7;
const MAX_CHART_ITEMS = 4;
const PERIOD_ITEMS = {
  Y: 'Y',
  M: 'M',
};

export default {
  props: {
    dataChart: {
      type: Array,
      default: () => [],
    },
    period: {
      type: String,
      default: PERIOD_ITEMS.Y,
      validator: (value) => {
        return [PERIOD_ITEMS.Y, PERIOD_ITEMS.M].includes(value);
      },
    },

    filterType: {
      type: Number,
      default: 1,
      validator: (value) => {
        return [1, 2].includes(value);
      },
    },
  },
  data() {
    return {
      AXIS_Y_ITEM_COUNT: AXIS_Y_ITEM_COUNT,
      MAX_CHART_ITEMS: MAX_CHART_ITEMS,
      PERIOD_ITEMS: PERIOD_ITEMS,
      indexAtFirstBar: 0,
      min: 0,
      max: 500,
      axisYItemsSource: [
        {
          value: 0,
          text: '0',
        },
        {
          value: 100,
          text: '100',
        },
        {
          value: 200,
          text: '200',
        },
        {
          value: 300,
          text: '300',
        },
        {
          value: 400,
          text: '400',
        },
        {
          value: 500,
          text: 't-CO2',
        },
      ],
      axisXItemsSource: [],
      dataChartPrepared: [],
      selectedTimeRange: '',
      hoverTimeRange: '',
      isMouseOverNext: false,
      isMouseOverPrev: false,
      isBlurNext: false,
      isBlurPrev: false,
      isFirstRender: true,
      transitionWidth: '100%',
      footerWidth: 0,
      processedData: [],
      emissionTooltip: {
        open: false,
        data: {},
        tooltipPosition: { left: 0, top: 0 },
      },
    };
  },
  computed: {
    ...mapState('product', ['newDashboard']),
    isNewDashboarRoute() {
      return isDashboardProductCFP(this.$route);
    },
    isDisabledNext() {
      return this.indexAtFirstBar + this.MAX_CHART_ITEMS >= this.dataChart.length;
    },
    isDisabledPrev() {
      return this.indexAtFirstBar <= 0;
    },
    isNegativeNumber() {
      return (this.dataChartPrepared || []).some((item) => item.isHasNegativeProduct === true);
    },
    nextIcon() {
      if (this.isDisabledNext) {
        return 'next-disabled';
      }

      if (this.isBlurNext) {
        return 'next';
      }

      if (this.isMouseOverNext) {
        return 'next-hover';
      }

      return 'next';
    },
    prevIcon() {
      if (this.isDisabledPrev) {
        return 'prev-disabled';
      }

      if (this.isBlurPrev) {
        return 'prev';
      }

      if (this.isMouseOverPrev) {
        return 'prev-hover';
      }

      return 'prev';
    },
    unitChartColumnYear() {
      return getUnitNewDashboardCFP();
    },
    axisYMinWidth() {
      return getMinWidthYAxisChartColumn(this.axisYItemsSource) || 0;
    },
    unitSetting() {
      return UNIT_SETTING;
    },
    dashboardStoreData() {
      return this.newDashboard.emissionsByProducts;
    },
    isFilterTypeProduct() {
      return this.filterType === 1;
    },
  },
  methods: {
    summaryEmission(dataChart = []) {
      return (dataChart || []).map((item) => {
        let negativeTotal = 0;
        let positiveTotal = 0;
        const dataMaster = this.handleGetDataByFilterType(item);
        if (dataMaster.length) {
          dataMaster.forEach((product) => {
            if ($_helper_isNumberType(product.total_emission)) {
              $_helper_isNegativeNumber(product.total_emission)
                ? (negativeTotal = formatBigNumber(
                    math.evaluate(
                      `${math.bignumber(formatValue(negativeTotal))} + ${math.bignumber(
                        formatValue(product.total_emission),
                      )}`,
                    ),
                  ))
                : (positiveTotal = formatBigNumber(
                    math.evaluate(
                      `${math.bignumber(formatValue(positiveTotal))} + ${math.bignumber(
                        formatValue(product.total_emission),
                      )}`,
                    ),
                  ));
            }
          });
          return [negativeTotal, positiveTotal];
        }
        return item.total_emission || 0;
      });
    },
    formatNumber(num, option) {
      if (num === 0) {
        return '---';
      }
      return formatNumberByConditions(num, option);
    },
    transformChartData() {
      const index = getIndexFromStoreData({
        type: this.period === 'Y' ? DASHBOARD_TYPE.YEAR : DASHBOARD_TYPE.MONTH_YEAR,
        storeData: {
          selectedYear: this.dashboardStoreData.selectedData.yearTab,
          selectedMonthYear: {
            month: this.dashboardStoreData.selectedData.monthTab.month,
            year: this.dashboardStoreData.selectedData.monthTab.year,
          },
        },
        dataList: this.dataChart,
      });

      const listIndex = this.dataChart.length - 1;

      if (index >= 0) {
        if (index < this.MAX_CHART_ITEMS) {
          this.indexAtFirstBar = index;
        } else if (index >= listIndex - 3) {
          // index in last 3 elements
          this.indexAtFirstBar = index === listIndex - 3 ? listIndex - 4 : listIndex - 3;
        } else {
          this.indexAtFirstBar = index;
        }
      } else {
        this.indexAtFirstBar = listIndex - 4;
      }

      this.prepareDataChart();
    },
    selectedFirstChartItem() {
      if (!this.dataChart.length) {
        return;
      }
      const index = getIndexFromStoreData({
        type: this.period === 'Y' ? DASHBOARD_TYPE.YEAR : DASHBOARD_TYPE.MONTH_YEAR,
        storeData: {
          selectedYear: this.dashboardStoreData.selectedData.yearTab,
          selectedMonthYear: {
            month: this.dashboardStoreData.selectedData.monthTab.month,
            year: this.dashboardStoreData.selectedData.monthTab.year,
          },
        },
        dataList: this.dataChart,
      });
      const item = this.dataChart[index];
      this.selectedTimeRange = item.time_range;
      this.$emit('selectChart', item, false);
    },
    /**
     * Prepare Axis X
     * @param dataChart List chart data
     */
    prepareAxisXChart(dataChart = []) {
      this.axisXItemsSource = (dataChart || []).map((item) => {
        return {
          label:
            this.period === this.PERIOD_ITEMS.Y
              ? this.isNewDashboarRoute
                ? formatDateRangeNewDashboardChart(item)
                : item.label
              : item.time_range,
          value: item.time_range,
          start_at: this.period === this.PERIOD_ITEMS.Y ? item.start_at : item.year,
          end_at: this.period === this.PERIOD_ITEMS.Y ? item.end_at : item.month,
        };
      });
    },
    /**
     * Prepare Axis Y
     */
    prepareAxisYChart(dataChart = []) {
      const summaryEmissionData = this.summaryEmission(dataChart);
      [this.axisYItemsSource, this.min, this.max] = prepareChartAxisY({
        totalList: summaryEmissionData || [],
        yItemCount: this.AXIS_Y_ITEM_COUNT,
        getUnitNewDashboard: this.unitChartColumnYear,
      });
    },
    /**
     * Prepare data
     */
    prepareDataChart() {
      if (!this.dataChart.length) {
        return;
      }

      if (this.dataChart.length <= this.MAX_CHART_ITEMS) {
        this.indexAtFirstBar = 0;
      }

      let dataChartOriginal = [];
      let index = 0;
      do {
        const item = this.dataChart[index + this.indexAtFirstBar];
        if (item) dataChartOriginal.push(item);
        index++;
      } while (index < this.MAX_CHART_ITEMS);

      this.prepareAxisXChart([...dataChartOriginal]);
      const timeout = this.isFirstRender ? 1000 : 0;

      setTimeout(() => {
        this.prepareAxisYChart([...dataChartOriginal]);

        this.dataChartPrepared = dataChartOriginal.map((item) => {
          const { negativeProduct, positiveProduct } = this.handlePrepareProductMaster(item);
          return {
            ...item,
            zero_value_ratio: `${Math.abs(Number(this.min) / (this.max - this.min)) * 100}%`,
            negativeProduct: negativeProduct,
            positiveProduct: positiveProduct,
            isHasNegativeProduct: negativeProduct?.length > 0,
            isHasPositiveProduct: positiveProduct?.length > 0,
          };
        });
      }, timeout);

      setTimeout(() => {
        this.transitionWidth = 0;
        this.footerWidth = this.$refs.axisYRef?.clientWidth || 0;
      }, timeout + 500);

      if (this.isFirstRender) {
        setTimeout(() => {
          this.isFirstRender = false;
        }, timeout + 500);
      }
    },
    handleGetValueChart(chartItem) {
      this.selectedTimeRange = chartItem.time_range;
      this.$emit('selectChart', chartItem, true);
    },
    handleMouseOver(item) {
      this.hoverTimeRange = item.time_range;
    },
    handleMouseLeave() {
      this.hoverTimeRange = '';
    },
    handleViewNext() {
      if (this.isDisabledNext) {
        return;
      }

      this.indexAtFirstBar = this.indexAtFirstBar + 1;
      this.prepareDataChart();
    },
    handleViewPrev() {
      if (this.isDisabledPrev) {
        return;
      }
      this.indexAtFirstBar = this.indexAtFirstBar - 1;
      this.prepareDataChart();
    },

    handleTooltipScroll() {
      this.emissionTooltip.open = false
    },

    updateTooltipPosition(event) {
      const element = document.getElementById('emission-tooltip');
      if (!element) return;

      const height = element?.clientHeight;
      var rect = event.target.getBoundingClientRect();
      this.emissionTooltip.tooltipPosition.left = rect.left - element?.clientWidth + 'px';

      let spacer = height;
      if (this.pastDurationChangeStatus) {
        spacer = height + 20;
      }
      this.emissionTooltip.tooltipPosition.top = event.clientY - spacer - 40 + 100 + 'px';
    },
    toolTipOn(item) {
      if (window.innerWidth < TABLET_WIDTH) {
        this.toolTipOff();
      } else {
        const prodDetail = { ...item };
        const itemName = this.isFilterTypeProduct ? prodDetail.name : prodDetail.category;
        if (itemName === 'other') {
          prodDetail.disp_title = this.isFilterTypeProduct
            ? this.$t('dashboard_cfp.other_products')
            : this.$t('dashboard_cfp.other_categories');
        } else {
          prodDetail.disp_title = this.isFilterTypeProduct
            ? `${itemName}/${prodDetail.lot_number ?? ''}`
            : `${prodDetail.category}`;
        }
        prodDetail.disp_emission = this.formatNumber(prodDetail.total_emission, { formatUnit: this.unitSetting.CO2 });
        prodDetail.disp_emission_unit = 'kg-CO2e';
        prodDetail.disp_link_detail = itemName !== 'other' ? this.$t('dashboard_cfp.product_details') : null;
        prodDetail.style = { color: itemName === 'other' ? DASHBOARD_COLOR[6] : prodDetail.style.backgroundColor };
        this.emissionTooltip.data = { ...prodDetail };
        this.emissionTooltip.open = true;
      }
    },
    toolTipOff(evt) {
      if (evt) {
        const tooltipEl = document.getElementById('emission-tooltip');
        if (!tooltipEl?.matches(':hover')) {
          this.emissionTooltip.data = {
            name: null,
            disp_title: null,
            disp_emission: null,
            disp_emission_unit: null,
            disp_link_detail: null,
          };
          this.emissionTooltip.open = false;
        }
      }
    },
    handlePrepareProductMaster(data) {
      let negativeProduct = [];
      let positiveProduct = [];
      const items = this.handleGetDataByFilterType(data);
      let colorIndex = 0;
      Object.values(items).forEach((item) => {
        const emission = math.bignumber(item.total_emission);
        if (math.smaller(emission, 0)) {
          negativeProduct.push({
            ...item,
            style: {
              height: `${Math.abs(Number(item.total_emission || 0) / this.min) * 100}%`,
              backgroundColor: this.handleGetColorByFilterType(item, colorIndex),
            },
          });
        } else if (math.larger(emission, 0)) {
          positiveProduct.push({
            ...item,
            style: {
              height: `${Math.abs(Number(item.total_emission || 0) / this.max) * 100}%`,
              backgroundColor: this.handleGetColorByFilterType(item, colorIndex),
            },
          });
        }
        colorIndex += 1;
      });
      return { negativeProduct, positiveProduct };
    },
    handleGetDataByFilterType(item) {
      return this.filterType === 1 ? item.product_master : item.category_master;
    },
    handleGetColorByFilterType(item, index) {
      const nameOther = this.filterType === 1 ? item.name : item.category;
      return nameOther === 'other' ? DASHBOARD_COLOR[5] : DASHBOARD_COLOR[index];
    },
    redirectLinkHrefToDetailProduct(item) {
      return this.$router.resolve({
        name: 'DetailProduct',
        params: { id: item.id },
        query: {
          ...this.$route.query,
          type: 'detail',
        },
      }).href;
    },
  },
  watch: {
    nextIcon() {
      if (this.isDisabledNext) {
        this.isBlurNext = false;
        this.isMouseOverNext = false;
      }
    },
    prevIcon() {
      if (this.isDisabledPrev) {
        this.isBlurPrev = false;
        this.isMouseOverPrev = false;
      }
    },
    dataChart() {
      this.transformChartData();
      this.selectedFirstChartItem();
    },
  },
  mounted() {
    this.footerWidth = this.$refs.axisYRef.clientWidth;
    window.addEventListener('scroll', this.handleTooltipScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleTooltipScroll);
  },
};
</script>
<style lang="scss" scoped>
@import './emission-chart.scss';
</style>
